import { render } from "./ScrollingDocument.vue?vue&type=template&id=0f38cc3c&scoped=true"
import script from "./ScrollingDocument.vue?vue&type=script&lang=js"
export * from "./ScrollingDocument.vue?vue&type=script&lang=js"

import "../../assets/scss/scrolling_document.scss?vue&type=style&index=0&id=0f38cc3c&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f38cc3c"]])

export default __exports__